module.exports = require("./mzn.js");